<template>
    <v-layout>
      <v-main class="app-main">
        <Menu ></Menu>
        <router-view/>
      </v-main>
    </v-layout>
</template>

<script>
import Menu from '../components/Menu.vue'

export default {
  data: () => ({
  }),
  components: {
    Menu
  }
}
</script>

<style>
.app-main {
  background-color: #F4F4F4;
  height: 100vh;
  width: 100vw;
}
</style>